var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"h6 text-center font-weight-bold",attrs:{"cols":"12"},domProps:{"innerHTML":_vm._s(_vm.header)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }